import React from 'react';

import instagram from '../../../assets/instagram.png';
import youtube from '../../../assets/youtube.png';


const SocialIcon = ({ source }) => {
  switch (source) {
    case 'instagram':
      return <img alt="" className="socialIconChat" src={instagram} />;
    case 'youtube':
      return <img alt="" className="socialIconChat" src={youtube} />;
    default:
      return null;
  }
};


export default SocialIcon;
